module.exports = __webpack_public_path__ + "img/19.b7fecc2d.png";